// @flow

import React from "react";
import { localize } from "redux-i18n";

import { ColumnsContainer } from "@components";
import type { Rows } from "@components/columns-container/types";
import type { EmailNotification } from "@modules/service/reducer/email-notifications/types";
import { EmailDistributionRulesEnum } from "@modules/service/constants";

type Props = $Exact<{
  data: ?EmailNotification,
  ...PropsFromLocalize,
}>;

export class EmailNotificationDistributionRulesView extends React.Component<Props> {
  get distributionRulesDetails() {
    const data = this.props.data || {};

    if (data.emailDistributionType === EmailDistributionRulesEnum.UPDATES_BATCHED_TOGETHER) {
      return [[this.props.t("EMAIL_NOTIFICATION_BATCH_FREQUENCY"), data.batchedEmailFrequency]];
    }

    if (data.emailDistributionType === EmailDistributionRulesEnum.AFTER_EVERY_ABSENCE) {
      return [
        [
          this.props.t("INCLUDE_RTW_DETAILS_IN_NOTIFICATIONS"),
          data.includeRtwDetailsInAbsenceNotifications ? this.props.t("YES") : this.props.t("NO"),
        ],
        [
          this.props.t("INCLUDE_ALERTS_IN_NOTIFICATIONS"),
          data.includeAlertsInAbsenceNotifications ? this.props.t("YES") : this.props.t("NO"),
        ],
      ];
    }

    return [];
  }

  get data(): Array<Rows> {
    const data = this.props.data || {};
    return [
      {
        columns: [
          {
            data: [
              [
                this.props.t("EMAIL_NOTIFICATION_EMAIL_DISTRIBUTION_TYPE"),
                this.props.t(data.emailDistributionType),
              ],
            ],
          },
          {
            data: [
              [
                this.props.t("EMAIL_NOTIFICATION_STARTS_NOTIFICATIONS"),
                data.startNotifications ? this.props.t("ACTIVE") : this.props.t("INACTIVE"),
              ],
            ],
          },
          {
            data: this.distributionRulesDetails,
          },
        ],
      },
    ];
  }

  render() {
    return <ColumnsContainer rows={this.data} />;
  }
}

export default localize()(EmailNotificationDistributionRulesView);
